import { Squad } from "../../types";

export const createSquadModel = (
  response: Squad
): Squad => response;
